import * as React from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  CardContent,
  Stack,
} from "@mui/material";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import BuildRoundedIcon from "@mui/icons-material/BuildRounded";

// Lägg till egna mallar och ikoner
const TEMPLATES = [
  {
    key: "marketing",
    title: "Marknadsföringsplan",
    description:
      "Planera kampanjer, följ upp leveranser och håll teamet på spåret.",
    Icon: CampaignRoundedIcon,
  },
  {
    key: "sales",
    title: "Säljpipeline",
    description:
      "Följ leads, affärer och kunddialoger i ett tydligt arbetsflöde.",
    Icon: MonetizationOnRoundedIcon,
  },
  {
    key: "it",
    title: "IT & ärendehantering",
    description: "Registrera, prioritera och lös ärenden snabbt och smidigt.",
    Icon: BuildRoundedIcon,
  },
];

// Lätt färgpalett
const COLORS = ["#F0F7FF", "#F9F7FF", "#FFF8F0", "#F0FFF8"];

export default function StepTemplateGallery({ value, onNext }) {
  const [selected, setSelected] = React.useState(value?.template || null);

  const handlePick = (tpl) => {
    setSelected(tpl.key);
    onNext?.({ template: tpl.key });
  };

  return (
    <Stack spacing={3} sx={{ p: 2 }}>
      <Box>
        <Typography variant="h4" fontWeight={800} gutterBottom>
          Välj en mall eller importera
        </Typography>
        <Typography color="text.secondary">
          Kickstarta med en färdig struktur, eller importera från fil/befintlig
          arbetsyta.
        </Typography>
      </Box>

      <Stack
        direction="row"
        spacing={2}
        useFlexGap
        flexWrap="wrap"
        justifyContent="flex-start"
      >
        {TEMPLATES.map((tpl, idx) => {
          const isActive = selected === tpl.key;
          const bg = COLORS[idx % COLORS.length];
          const Icon = tpl.Icon;
          return (
            <Card
              key={tpl.key}
              sx={{
                width: 260,
                border: isActive ? "2px solid" : "1px solid",
                borderColor: isActive ? "primary.main" : "divider",
                borderRadius: 2,
                transition: "all .2s ease",
                bgcolor: bg,
                "&:hover": {
                  boxShadow: "0 0 16px rgba(25,118,210,.25)",
                  transform: "translateY(-2px)",
                },
                ...(isActive && {
                  boxShadow: "0 0 0 3px rgba(25,118,210,.3)",
                }),
              }}
            >
              <CardActionArea
                sx={{ height: "100%" }}
                onClick={() => handlePick(tpl)}
              >
                <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  <Icon
                    fontSize="large"
                    sx={{ color: "primary.main", mb: 1 }}
                  />
                  <Typography variant="subtitle1" fontWeight={700} gutterBottom>
                    {tpl.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ lineHeight: 1.4 }}
                  >
                    {tpl.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          );
        })}
      </Stack>
    </Stack>
  );
}
